module.exports = __webpack_public_path__ + "media/images/payment-4-5623e8a3d772b8874459277a72bdc18c.svg";